import { BannerGhostLoading } from '@components/Home/Banner/BannerGhostLoading'
import { ContinueLessonsGhostLoading } from '@components/Home/Continue/ContinueLessonsGhostLoading'
import { AppLayout } from '@layouts/AppLayout'

export function HomeLoadingSkeleton() {
  return (
    <AppLayout
      backRoute={{
        label: '',
        shouldDisplayLogo: true,
      }}
    >
      <BannerGhostLoading />
      <ContinueLessonsGhostLoading />
    </AppLayout>
  )
}
